// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var MetaDataKeys;
(function (MetaDataKeys) {
    MetaDataKeys["META_DATA_UNKNOWN"] = "META_DATA_UNKNOWN";
    MetaDataKeys["SCHEDULE_CALL_DATE"] = "SCHEDULE_CALL_DATE";
    MetaDataKeys["PORT_DATES"] = "PORT_DATES";
    MetaDataKeys["PHONES_SHIPPED_DATE"] = "PHONES_SHIPPED_DATE";
})(MetaDataKeys || (MetaDataKeys = {}));
export var MetaDataKeys_index;
(function (MetaDataKeys_index) {
    MetaDataKeys_index[MetaDataKeys_index["META_DATA_UNKNOWN"] = 0] = "META_DATA_UNKNOWN";
    MetaDataKeys_index[MetaDataKeys_index["SCHEDULE_CALL_DATE"] = 1] = "SCHEDULE_CALL_DATE";
    MetaDataKeys_index[MetaDataKeys_index["PORT_DATES"] = 2] = "PORT_DATES";
    MetaDataKeys_index[MetaDataKeys_index["PHONES_SHIPPED_DATE"] = 3] = "PHONES_SHIPPED_DATE";
})(MetaDataKeys_index || (MetaDataKeys_index = {}));
/**
 * OnboardingTasksAPIV2 is the V2 version of the Onboarding Tasks API.This is created to handle the task related requirements for Fast Pass
 */
export const OnboardingTasksAPIV2 = {
    /**
     * GetModulesAndTasksByLocationID Returns all the modules and tasks for a given locationID. This will be used for Locations that go through the Fast-Pass
     */
    GetModulesAndTasksByLocationId(fn, req) {
        return fn(`/insys/onboarding/v2/onboarding-tasks/modules-tasks?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
